import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { LoaderModule } from '@core/loader/loader.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { SharedModule } from '@shared/shared.module';
import { EquationsModule } from '../equations/equations.module';
import { ExogenousLinesEquationsComponent } from './exogenous-lines-equations.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SpreadSheetsModule,
    MatTreeModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatIconModule,
    LoaderModule,
    EquationsModule,
    MatTooltipModule
  ],
  declarations: [ExogenousLinesEquationsComponent]
})
export class ExogenousLinesEquationsModule {}
